<div class="wrapper">
  @if (!fullScreen) {
    <div
      class="sidebar"
      data-color="purple"
      data-background-color="white"
      >
      <app-sidebar></app-sidebar>
    </div>
  }
  <div class="main-panel" [class.full]="fullScreen">
    @if (!fullScreen) {
      <div class="main-panel-topbar">
        <app-navbar></app-navbar>
      </div>
    }
    <div class="main-panel-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
